import {Exclude, Expose} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";

@Exclude()
export class AppConfigApiModel extends AbstractApiModel {
  @Expose() public channelCode: string;
  @Expose() public localeCode: string;
  @Expose() public registrationClosed: boolean;
  @Expose() public registrationWhitelist: string;
  @Expose() public standardRegistrationAccessCodeEnabled: boolean;
  @Expose() public oauthCompletionAccessCodeEnabled: boolean;
  @Expose() public mobileShellEnabled: boolean;
  @Expose() public mobileTopNavigationEnabled: boolean;
  @Expose() public mobileVehicleWizardEnabled: boolean;
  @Expose() public mobileFlutterVehicleWizardEnabled: boolean;
  @Expose() public mobileFlutterSocialListEnabled: boolean;
  @Expose() public mobileFlutterMediaComposerEnabled: boolean;
  @Expose() public mobileEventCreationEnabled: boolean;
  @Expose() public mobileAdvertisementCreationEnabled: boolean;
  @Expose() public mobileCollaborationCreationEnabled: boolean;
  @Expose() public createdAt?: Date;
  @Expose() public updatedAt?: Date;
}
